import axios from 'axios';

/**
 * Confidence level for harmonization suggestions
 * @typedef {'High' | 'Medium' | 'Low'} ConfidenceLevel
 */

/**
 * @typedef {object} HarmonizationSuggestion
 * @property {string} suggestedCode
 * @property {string} reasoning
 * @property {ConfidenceLevel} confidenceLevel
 * @property {string} [referenceChapter] - Optional reference chapter description
 */

/**
 * @typedef {object} HarmonizationResponse
 * @property {number} productId
 * @property {Array<HarmonizationSuggestion>} suggestions
 */

/**
 * @typedef {object} BulkResultItem
 * @property {number} productId
 * @property {string} productName
 * @property {Array<HarmonizationSuggestion>} suggestions
 * @property {string} [error] - Error message if generation failed for this product
 * @property {boolean} hadDescription - Whether product had description data
 */

/**
 * @typedef {object} BulkResultsSummary
 * @property {number} totalProducts
 * @property {number} successful
 * @property {number} failed
 * @property {number} productsWithoutDescriptions
 * @property {number} processingTimeSeconds
 */

/**
 * Generate harmonization code for a single product
 * @param {number} productId
 * @param {string} [productDescription]
 * @param {string} [customsDescription]
 * @param {string} [workflowGuid] - Workflow GUID for tracking
 * @returns {Promise<HarmonizationResponse>}
 */
export const generateHarmonizationCode = async (productId, productDescription, customsDescription, workflowGuid) => {
  const response = await axios.post('/product/harmonization/generate-single', {
    productId,
    productDescription,
    customsDescription,
    workflowGuid,
  });
  return response.data;
};
